import React, { Fragment } from 'react';
import _ from 'lodash';
import DDadosBase from '@common/components/ddados/ddados.base';
import Field from '@common/components/validation/field.validation';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
  }

  onChange(field, form) {
    return (e) => {
      form.setFieldValue(this.props.name, e.target.checked);
      this.dispatchChanges(e.target.checked, form, field);
    };
  }

  renderComponent() {
    const { props } = this;
    const { Label, isView, Tooltip, LabelSpace, name, Desabilitado, LabelSpaceVertical, PlacementTooltip } = props;

    return (
      <Field {...props}>
        {({ value, onChange }) => {
          return (
            <Fragment>
              {LabelSpaceVertical && <label>&nbsp;</label>}

              <OverlayTrigger
                key={`top-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  Tooltip || Label ? (
                    <TooltipBootstrap id={`tooltip-${name}`}>
                      <div className={'fontTooltip'}>{Tooltip || Label}</div>
                    </TooltipBootstrap>
                  ) : (
                    <div />
                  )
                }
              >
                <div style={{ width: 'fit-content' }}>
                  <Fragment>
                    <label className="tooltipLabel">
                      <input
                        className="checkbox-inline"
                        type="checkbox"
                        checked={value || false}
                        disabled={isView || Desabilitado}
                        onChange={(e) => {
                          onChange(e.target.checked);
                        }}
                      />
                      {LabelSpace && <Fragment>&nbsp;</Fragment>}
                      {Label}
                    </label>
                  </Fragment>
                </div>
              </OverlayTrigger>
            </Fragment>
          );
        }}
      </Field>
    );
  }

  renderView() {
    const { props } = this;
    const { Label, LabelSpace, LabelSpaceVertical } = props;

    return (
      <Field {...props}>
        {({ value }) => {
          return (
            <div>
              <Fragment>
                {LabelSpaceVertical && <label>&nbsp;</label>}
                <label className="tooltipLabel">
                  <input className="checkbox-inline" type="checkbox" checked={value || false} disabled={true} />
                  {LabelSpace && <Fragment>&nbsp;</Fragment>}
                  {Label}
                </label>
              </Fragment>
            </div>
          );
        }}
      </Field>
    );
  }
}

export default DDadosComponent;
